"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ExtendedRiverfly_exports = {};
__export(ExtendedRiverfly_exports, {
  ExtendedRiverflySiltAndFlow: () => ExtendedRiverflySiltAndFlow,
  ExtendedRiverflyWaterQuality: () => ExtendedRiverflyWaterQuality
});
module.exports = __toCommonJS(ExtendedRiverfly_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_types = require("@cartographerio/types");
var import_core = require("../../core/index.js");
var import_helpers = require("./helpers.js");
const ExtendedRiverflyWaterQuality = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("extendedRiverflyWaterQuality"),
  title: "Extended Riverfly Water Quality",
  layers: [
    (0, import_helpers.extendedRiverflyWaterQualityLayer)((0, import_types.unsafeProjectAlias)("extendedriverfly"), "Data from Extended Riverfly Surveys")
  ]
});
const ExtendedRiverflySiltAndFlow = (0, import_core.mapSchemaWithDefaults)({
  mapId: (0, import_topo_map.unsafeMapId)("extendedRiverflySiltAndFlow"),
  title: "Extended Riverfly Silt and Flow",
  layers: [
    (0, import_helpers.extendedRiverflySiltAndFlowLayer)((0, import_types.unsafeProjectAlias)("extendedriverfly"), "Data from Extended Riverfly Surveys")
  ]
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ExtendedRiverflySiltAndFlow,
  ExtendedRiverflyWaterQuality
});
//# sourceMappingURL=ExtendedRiverfly.js.map
